/**
 * SkeletonBar — Barra animada de skeleton loading
 */
import type { JSX } from 'preact';
import { T } from '../../styles/tokens';

interface SkeletonBarProps {
  width?: string | number;
  height?: number;
  style?: JSX.CSSProperties;
}

export function SkeletonBar({ width = '100%', height = 14, style }: SkeletonBarProps) {
  return (
    <div style={{
      width,
      height,
      borderRadius: 6,
      background: `linear-gradient(90deg, ${T.bgCard} 25%, ${T.bgCardHover} 50%, ${T.bgCard} 75%)`,
      backgroundSize: '200% 100%',
      animation: 'shimmer 1.5s ease-in-out infinite',
      ...style,
    }} />
  );
}
